<template>
  <div
    @mouseover="getAssociatedCasesLabels"
    @mouseleave="hideAllTooltips"
  >
    <associated-cases-badge
      v-if="valueIsDefined"
      :id="uniqueId"
      v-tooltip.html.right.noninteractive="associatedCaseLabels"
      :associated="params.value"
    />
  </div>
</template>

<script>

import Vue from 'vue'
import AssociatedCasesBadge from '@/components/common/AssociatedCasesBadge'
import commonCaseServices from '@/api/resources/common/commonCaseServices'
import { uniqueId } from 'lodash'

export default Vue.extend({
    name: 'AssociatedCasesRenderer',
    components: {
        AssociatedCasesBadge
    },
    data() {
        return {
            associatedCaseLabels: null
        }
    },
    computed: {
        valueIsDefined() {
            return this.params.value > 0
        },
        uniqueId() {
            return uniqueId(this.params.value)
        }
    },
    methods: {
        async getAssociatedCasesLabels() {
            if (this.valueIsDefined) {
                this.hideAllTooltips()
                const laboratoryId = this.params?.node.data.laboratory.labId
                const caseId = this.params?.node.data.id
                const [err, response] = await this.$_toCall(commonCaseServices.getAssociatedCases(laboratoryId, caseId), true)
                if (err) {
                    this.associatedCaseLabels = null
                }
                const associatedCases = response.map(associatedCase => associatedCase.casenumber)
                this.associatedCaseLabels = associatedCases.join('<br>')
                this.showTooltip()
            }
        },
        hideAllTooltips() {
            this.$root.$emit('bv::hide::tooltip')
        },
        showTooltip() {
            this.$root.$emit('bv::show::tooltip', this.uniqueId)
        }
    }
})

</script>
